<form [formGroup]="outletForm" class="mb-20">
    <div class="col-lg-12">
        <fieldset>
            <legend>Outlet Details</legend>
            <div class="row">
                <div class="col-lg-4">
                    <div class="form-group">
                        <div class="text-box-wrap">
                            <label>*Outlet Name</label>
                            <input type="text" formControlName="name" class="form-control"
                                [ngClass]="{'is-invalid': formErrors.name}" maxlength="50">
                            <div *ngIf="fc.name.errors" class="invalid-feedback">
                                <div *ngIf="fc.name.errors.required">
                                    Required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="text-box-wrap">
                            <label>*Owner Name</label>
                            <input type="text" formControlName="ownerName" class="form-control"
                                [ngClass]="{'is-invalid': formErrors.ownerName}" maxlength="50">
                            <div *ngIf="fc.ownerName.errors" class="invalid-feedback">
                                <div *ngIf="fc.ownerName.errors.required">
                                    Required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="text-box-wrap">
                            <label>*Time Zone</label>
                            <select [ngClass]="{'is-invalid': formErrors.timeZoneId}" class="form-control"
                                formControlName="timeZoneId">
                                <option [ngValue]="null">Select</option>
                                <option *ngFor="let item of timeZoneList" [value]="item.key">{{item?.value}}</option>
                            </select>
                            <div *ngIf="fc.timeZoneId.errors" class="invalid-feedback">
                                <div *ngIf="fc.timeZoneId.errors.required">
                                    Required
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4">
                    <div class="form-group" *ngIf="id === 0 || outlet">
                        <div class="text-box-wrap">
                            <label>*Outlet Contact No</label>
                            <input [appPhoneNumberFormatter]="this.outletForm.get('mobile').value" type="text"
                                formControlName="mobile" class="form-control"
                                [ngClass]="{'is-invalid': formErrors.mobile}" maxlength="14">
                            <div *ngIf="fc.mobile.errors" class="invalid-feedback">
                                <div *ngIf="fc.mobile.errors.required">
                                    Required
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="form-group" *ngIf="id === 0 || outlet">
                        <div class="text-box-wrap">
                            <label>Owner Contact No</label>
                            <input [appPhoneNumberFormatter]="this.outletForm.get('mobile2').value" type="text"
                                formControlName="mobile2" class="form-control"
                                [ngClass]="{'is-invalid': formErrors.mobile2}" maxlength="14">
                            <div *ngIf="fc.mobile2.errors" class="invalid-feedback">
                                <div *ngIf="fc.mobile2.errors.required">
                                    Required
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <div class="form-group">
                        <div class="text-box-wrap" [hidden]="isOutlet">
                            <label>*Login username for outlet</label>&nbsp; <a (click)="addNewOption()"><i
                                    class="fa fa-plus green" aria-hidden="true"></i></a>
                            <div class="label-none" formArrayName="mobileList"
                                *ngFor="let item of outletForm.get('mobileList')['controls']; let i = index;">
                                <div class="flex-ctrl" [formGroupName]="i">
                                    <div class="row">
                                        <div class="form-group col-5">
                                            <div class="text-box-wrap">
                                                <input type="text" formControlName="name" class="form-control"
                                                    name="name" placeholder="Name"
                                                    [ngClass]="{'is-invalid': mobileListFormArray.controls[i].get('name').errors}"
                                                    maxlength="100">
                                                <div class="invalid-feedback"
                                                    *ngIf="mobileListFormArray.controls[i].get('name').errors?.required">

                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-5">
                                            <div class="text-box-wrap">
                                                <input type="text" formControlName="mobile" class="form-control"
                                                    numberOnly placeholder="Mobile"
                                                    [ngClass]="{'is-invalid': mobileListFormArray.controls[i].get('mobile').errors}"
                                                    maxlength="10">
                                                <div class="invalid-feedback"
                                                    *ngIf="mobileListFormArray.controls[i].get('mobile').errors?.required">

                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group col-2">
                                            <a [hidden]="mobileListFormArray.controls.length <= 1"
                                                href="javascript:void(0)" (click)="removeOption(i)"><i
                                                    class="fa fa-trash red fa-lg" aria-hidden="true"></i></a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="col-lg-4">
                    <div class="form-group">
                        <div class="text-box-wrap">
                            <label>*Email / Username</label>
                            <input type="text" formControlName="email" class="form-control"
                                [ngClass]="{'is-invalid': formErrors.email}" maxlength="50">
                            <div *ngIf="fc.email.errors" class="invalid-feedback">
                                <div *ngIf="fc.email.errors.required">
                                    Required
                                </div>
                                <div *ngIf="fc.email.errors.email">
                                    Invalid Email
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="text-box-wrap">
                            <label>Description</label>
                            <textarea formControlName="description" class="form-control"
                                [ngClass]="{'is-invalid': formErrors.description}" maxlength="1000"></textarea>
                            <div *ngIf="fc.description.errors" class="invalid-feedback">
                                <div *ngIf="fc.description.errors.required">
                                    Required
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <!-- <div class="row">
                <div class="col-lg-12">
                    <div class="form-group">
                        <div class="text-box-wrap">
                            <label>*Merchant Email(s)  <span style="color: green; font-size: small;">[For Receiving new orders]</span></label>
                            <p-chips  name="merchantEmail"
                                formControlName="merchantEmail" separator=","></p-chips>
                               <span style="color: green; font-size: small;"> Note: Put comma after the email</span>
                        </div>
                    </div>
                </div>
            </div> -->
        </fieldset>
    </div>

    <div class="col-lg-12">
        <fieldset>
            <legend>Address Details </legend>
            <div class="row">
                <div class="col-lg-4">
                    <div class="form-group">
                        <div class="text-box-wrap">
                            <label>*Country</label>
                            <select (change)="getStates()" [ngClass]="{'is-invalid': formErrors.countryId}"
                                class="form-control" formControlName="countryId">
                                <option [ngValue]="null">Select</option>
                                <option *ngIf="!isProd" [value]="country.India">India</option>
                                <option [value]="country.Usa">USA</option>
                            </select>
                            <div *ngIf="fc.countryId.errors" class="invalid-feedback">
                                <div *ngIf="fc.countryId.errors.required">
                                    Required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="text-box-wrap">
                            <label>*Zip Code</label>
                            <input numberOnly type="text" formControlName="zipCode" class="form-control"
                                [ngClass]="{'is-invalid': formErrors.zipCode}" maxlength="6">
                            <div *ngIf="fc.zipCode.errors" class="invalid-feedback">
                                <div *ngIf="fc.zipCode.errors.required">
                                    Required
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="col-lg-4">
                    <div class="form-group">
                        <div class="text-box-wrap">
                            <label>*State</label>
                            <select (change)="getCities()" [ngClass]="{'is-invalid': formErrors.stateId}"
                                class="form-control" formControlName="stateId">
                                <option [ngValue]="null">Select</option>
                                <option *ngFor="let item of stateList" [value]="item.key">{{item?.value}}</option>
                            </select>
                            <div *ngIf="fc.stateId.errors" class="invalid-feedback">
                                <div *ngIf="fc.stateId.errors.required">
                                    Required
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="form-group">
                        <div class="text-box-wrap">
                            <label>Map Location</label>
                            <input type="text" formControlName="mapLocation" class="form-control"
                                [ngClass]="{'is-invalid': formErrors.mapLocation}" maxlength="50">
                            <div *ngIf="fc.mapLocation.errors" class="invalid-feedback">
                                <div *ngIf="fc.mapLocation.errors.required">
                                    Required
                                </div>
                            </div>
                        </div>
                    </div> -->
                    <ic-google-address *ngIf="address" [googleAddress]="address"
                        (googleAddressEvent)="googleAddressEvent($event)">
                    </ic-google-address>

                </div>

                <div class="col-lg-4">
                    <div class="form-group">
                        <div class="text-box-wrap">
                            <label>*City</label>
                            <select [ngClass]="{'is-invalid': formErrors.cityId}" class="form-control"
                                formControlName="cityId">
                                <option [ngValue]="null">Select</option>
                                <option *ngFor="let item of cityList" [value]="item.key">{{item?.value}}</option>
                            </select>
                            <div *ngIf="fc.cityId.errors" class="invalid-feedback">
                                <div *ngIf="fc.cityId.errors.required">
                                    Required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="text-box-wrap">
                            <label>*Address</label>
                            <textarea formControlName="address" class="form-control"
                                [ngClass]="{'is-invalid': formErrors.address}" maxlength="50"></textarea>
                            <div *ngIf="fc.address.errors" class="invalid-feedback">
                                <div *ngIf="fc.address.errors.required">
                                    Required
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </fieldset>
    </div>

</form>

<div class="modal-footer">
    <button *ngIf="!profile" (click)="onPrevious()" type="button" class="btn btn-secondary">Cancel</button>
    <button type="button" (click)="onSave()" [disabled]="!outletForm.valid" class="btn btn-success">Save</button>
</div>